export default __webpack_public_path__ + "static/media/video-off.81281c31.svg";